import { Button } from 'antd';
import styled, { css } from 'styled-components';

// antd Select/Input/DatePicker/Button 높이를 40px로 통일 (&&: antd 기본 스타일보다 우선순위 확보)
const controlHeight40 = css`
  && .ant-picker {
    height: 40px;
  }

  && .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 40px;
    align-items: center;
  }

  && .ant-select-single .ant-select-selector .ant-select-selection-item,
  && .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 38px;
  }

  && .ant-select-single .ant-select-selector .ant-select-selection-search-input {
    height: 38px;
  }

  && input.ant-input {
    height: 40px;
  }

  && .ant-btn {
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 18px;
  margin-bottom: 16px;
  background: #ffffff;

  ${controlHeight40}

  .filter-label {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color: #212529;
  }
`;

export const SummaryCardList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
`;

export const SummaryCard = styled.div<{ $countColor?: string }>`
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;

  .summary-label {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #212529;
  }

  .summary-count {
    margin-top: 8px;
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    color: ${({ $countColor }) => $countColor || '#212529'};
  }
`;

export const TableTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-bottom: 16px;

  .table-notice {
    font-size: 14px;
    line-height: 18px;
    color: #212529;
  }
`;

export const StatusText = styled.span<{ $color?: string }>`
  color: ${({ $color }) => $color || '#212529'};
`;

export const OrderNoButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: #3478f6;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  .anticon {
    margin-left: 4px;
    font-size: 12px;
  }
`;

export const DetailTableWrapper = styled.div`
  max-height: 55vh;
  overflow-y: auto;
  border-top: 1px solid #f0f0f0;
`;

export const DetailRow = styled.div`
  display: flex;
  border-bottom: 1px solid #f0f0f0;

  .detail-label {
    flex: 0 0 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    padding: 8px;
    background: #fafafa;
    font-size: 14px;
    font-weight: 700;
    color: #212529;
  }

  .detail-value {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    font-size: 14px;
    text-align: center;
    word-break: break-all;
  }
`;

export const ShippingEditArea = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-top: 20px;

  ${controlHeight40}

  .field {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .field-label {
    font-size: 14px;
    font-weight: 700;
    color: #212529;
  }
`;

// 삭제 버튼: 기본은 일반, hover/focus 시 에러(빨강) 색상
export const DeleteButton = styled(Button)`
  &&:hover,
  &&:focus {
    color: #ff4d4f;
    border-color: #ff4d4f;
  }
`;

export const ShippingEditNotice = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 12px 0 0;
  font-size: 13px;
  color: #6d7582;
`;

export const UploadDesc = styled.p`
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 20px;
  color: #212529;
`;

export const StepCardList = styled.ol`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 0 0 16px;
  padding: 0;
  list-style: none;

  li {
    padding: 14px 16px;
    background: #f4f6f3;
    border-radius: 6px;

    .step-no {
      font-size: 13px;
      line-height: 18px;
      color: #6d7582;
    }

    .step-label {
      margin-top: 4px;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      color: #212529;
    }
  }
`;

export const FileBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  margin-bottom: 20px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;

  .file-name {
    font-size: 15px;
    font-weight: 700;
    color: #212529;
    word-break: break-all;
  }

  .file-hint {
    display: block;
    margin-top: 4px;
    font-size: 13px;
    color: #6d7582;
  }
`;

export const AnalysisSection = styled.div`
  .analysis-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 12px;

    .analysis-title {
      font-size: 15px;
      font-weight: 700;
      color: #212529;
    }

    .success {
      font-weight: 700;
      color: #46b476;
    }

    .fail {
      font-weight: 700;
      color: #e5484d;
    }
  }

  .analysis-table-scroll {
    max-height: 260px;
    overflow-y: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;

    th {
      padding: 12px 16px;
      background: #f7f7f7;
      font-size: 14px;
      font-weight: 700;
      text-align: left;
      color: #212529;
    }

    td {
      padding: 14px 16px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 14px;
      color: #212529;
    }

    td.fail-reason {
      color: #e5484d;
    }
  }
`;

export const UploadModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  .footer-right {
    display: flex;
    gap: 8px;
  }
`;
